import { render, staticRenderFns } from "./AnswerInput.vue?vue&type=template&id=0e651f02&scoped=true&"
import script from "./AnswerInput.vue?vue&type=script&lang=ts&"
export * from "./AnswerInput.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerInput.vue?vue&type=style&index=0&id=0e651f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e651f02",
  null
  
)

export default component.exports